import { useEffect, useState } from 'react';

// material-ui
import { 
  CircularProgress,
  Typography,
  Snackbar,
  Alert 
} from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import NavCollapse from './NavCollapse';
import menuItem from 'menu-items/AdminMenu';
import { getAccessByToken } from 'API/Access/apis';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
  const [Access, setAccess] = useState();
  const [AccessErr, setAccessErr] = useState(false);
  const [expanded, setExpanded] = useState(null); // Track the currently expanded menu

  useEffect(() => {
    getAccessByToken(setAccess, setAccessErr);
  }, []);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setAccessErr(false);
  };

  const navItems = menuItem.items.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup access={Access} key={item.id} item={item} expanded={expanded} setExpanded={setExpanded} />;
      case 'collapse':
        return <NavCollapse key={item.id} menu={item} expanded={expanded} setExpanded={setExpanded} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return Access ? (
    <>
      {navItems}
    </>
  ) : (
    <>
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={AccessErr} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="error" variant="filled" sx={{ width: '100%' }}>
          Access denied
        </Alert>
      </Snackbar>
      <CircularProgress />
    </>
  );
};

export default MenuList;
